import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "../ui/dialog";
import { EnquiryForm } from "./EnquiryForm";

export const BrochureDialog = ({ label, brand = "", accent, accentText }) => (
  <Dialog>
    <DialogTrigger asChild>
      <button
        data-testid="brochure-dialog-trigger"
        className="btn-brochure"
        style={accent ? { backgroundColor: accent, color: accentText } : {}}
      >
        {label}
      </button>
    </DialogTrigger>
    <DialogContent className="bg-[#0B162C] border-white/15 text-white max-w-xl">
      <DialogHeader>
        <DialogTitle className="font-display uppercase tracking-tight text-2xl text-white">
          Request the {brand} brochure
        </DialogTitle>
      </DialogHeader>
      <p className="text-sm text-white/55 -mt-1 mb-2">
        Leave your details and we'll send the brochure directly to your inbox, and answer any
        questions about the range.
      </p>
      <EnquiryForm defaultProduct="Brochure Request" />
    </DialogContent>
  </Dialog>
);
